import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2507 5.41732C11.2507 4.72696 10.691 4.16732 10.0007 4.16732C9.3103 4.16732 8.75065 4.72696 8.75065 5.41732C8.75065 6.10767 9.3103 6.66732 10.0007 6.66732C10.691 6.66732 11.2507 6.10767 11.2507 5.41732Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.16732 8.33398L9.16732 15.0007H10.834V8.33398H9.16732Z",
			fill: "#005AA0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.0007 19.1673C15.0633 19.1673 19.1673 15.0633 19.1673 10.0007C19.1673 4.93804 15.0633 0.833984 10.0007 0.833984C4.93804 0.833984 0.833984 4.93804 0.833984 10.0007C0.833984 15.0633 4.93804 19.1673 10.0007 19.1673ZM10.0007 17.5007C14.1428 17.5007 17.5007 14.1428 17.5007 10.0007C17.5007 5.85852 14.1428 2.50065 10.0007 2.50065C5.85852 2.50065 2.50065 5.85852 2.50065 10.0007C2.50065 14.1428 5.85852 17.5007 10.0007 17.5007Z",
			fill: "#005AA0"
		})
	]
});
const ForwardRef = forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
